// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.translateContainer {
  background-color: #f2f2f2;
  margin-left: 15%;
  margin-right: 15%;
}

.translateH3 {
  font-size: 24px;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
  margin-top: 70px;
  margin-bottom: 20px;
  color: #797979;
}

.translateH3 .translateH3Arrow {
  font-size: 16px;
}

.searchTranslateContainer {
  background: #ffffff;
  padding: 15px;
  margin-bottom: 15px;
  box-sizing: border-box;
  color: #797979;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  box-shadow: 3px 3px 3px 3px #aab2bd;
  margin-left: 15%;
  margin-right: 15%;
}

.searchTranslateHeading {
  font-size: 18px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-family: "Ruda", sans-serif;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
}

.fileUploadTrans {
  display: flex;
  width: 100%;
  margin-bottom: 20px;
}

.uploadTransH4 {
  font-size: 16px;
  margin-bottom: 10px;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  color: #797979;
  margin-top: 15px;
  margin-left: 8%;
  width: 213px;
}

.uploadTransPDFIcon {
  font-size: 24px;
  padding-top: 0px;
  vertical-align: middle;
}

.fileChooseTrans {
  box-sizing: border-box;
  width: 52%;
  position: relative;
  max-height: 35px;
  font-family: "Ruda", sans-serif;
  margin-left: 4%;
  margin-right: 11%;
  /* margin-top: 15px; */
  border-radius: 4px;
  outline-color: #68dff0;
  /* margin-bottom: 10px; */
  color: #fff;
  background-color: #68dff0;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid #48bcb4;
  padding: 6px 12px;
  cursor: pointer;
}

.thumbnailContainerTrans {
  padding: 5px;
  position: relative;
  left: 38.4%;
  width: 60%;
}

.transButtonContainer {
  background: #ffffff;
  padding: 15px;
  margin-bottom: 15px;
  box-sizing: border-box;
  color: #797979;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  box-shadow: 3px 3px 3px 3px #aab2bd;
  margin-left: 15%;
  margin-right: 15%;
}

.transButtonSearch {
  color: #fff;
  background-color: #68dff0;
  box-shadow: inset 0 3px 5px rgb(0 0 0 / 13%);
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  border: 1px solid #48bcb4;
  border-radius: 4px;
  cursor: pointer;
}
.transButtonSearch:hover {
  background-color: #51cac2;
}

.transButtonSearch:active {
  background-color: #327e79;
}

.fileChooseTransNot {
  box-sizing: border-box;
  width: 52%;
  position: relative;
  max-height: 35px;
  font-family: "Ruda", sans-serif;
  margin-left: 4.3%;
  margin-right: 11%;
  /* margin-top: 15px; */
  border-radius: 4px;
  outline-color: #68dff0;
  /* margin-bottom: 10px; */
  color: #fff;
  background-color: #68dff0;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid #48bcb4;
  padding: 6px 12px;
  cursor: not-allowed;
}

.dropdownLabelTrans {
  font-size: 16px;
  margin-top: 8px;
  margin-bottom: 5px;
  font-weight: 500;
  margin-right: 3%;
  width: 20%;
  margin-left: 9%;
  color: #797979;
  font-family: "Ruda", sans-serif;
}

.dropdownSelectTrans {
  box-sizing: border-box;
  width: 52%;
  position: relative;
  max-height: 35px;
  padding-right: 15px;
  padding-left: 15px;
  color: #555;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  line-height: 1.42857143;
  margin-left: 4%;
  margin-right: 11%;
  border-radius: 4px;
  border: 1px solid #ccc;
  outline-color: #68dff0;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}

.loadingDivTrans {
  display: inline-flex;
  height: 30px;
  width: 290px;
  position: absolute;
}

.loadingTextDataTrans {
  color: #797979;
  font-family: "Ruda", sans-serif;
  font-size: 16px;
  margin-top: 8px;
  margin-bottom: 5px;
  font-weight: 500;
  margin-right: 4%;
  width: 180px;
  margin-left: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Screens/TranslateQuestions/TranslateComponets/TranslateOptions/translateOptions.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,4CAA4C;EAC5C,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,+BAA+B;EAC/B,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,wEAAwE;AAC1E;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB","sourcesContent":[".translateContainer {\n  background-color: #f2f2f2;\n  margin-left: 15%;\n  margin-right: 15%;\n}\n\n.translateH3 {\n  font-size: 24px;\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  color: inherit;\n  margin-top: 70px;\n  margin-bottom: 20px;\n  color: #797979;\n}\n\n.translateH3 .translateH3Arrow {\n  font-size: 16px;\n}\n\n.searchTranslateContainer {\n  background: #ffffff;\n  padding: 15px;\n  margin-bottom: 15px;\n  box-sizing: border-box;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  box-shadow: 3px 3px 3px 3px #aab2bd;\n  margin-left: 15%;\n  margin-right: 15%;\n}\n\n.searchTranslateHeading {\n  font-size: 18px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  font-family: \"Ruda\", sans-serif;\n  font-weight: 500;\n  line-height: 1.1;\n  color: inherit;\n}\n\n.fileUploadTrans {\n  display: flex;\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.uploadTransH4 {\n  font-size: 16px;\n  margin-bottom: 10px;\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  color: #797979;\n  margin-top: 15px;\n  margin-left: 8%;\n  width: 213px;\n}\n\n.uploadTransPDFIcon {\n  font-size: 24px;\n  padding-top: 0px;\n  vertical-align: middle;\n}\n\n.fileChooseTrans {\n  box-sizing: border-box;\n  width: 52%;\n  position: relative;\n  max-height: 35px;\n  font-family: \"Ruda\", sans-serif;\n  margin-left: 4%;\n  margin-right: 11%;\n  /* margin-top: 15px; */\n  border-radius: 4px;\n  outline-color: #68dff0;\n  /* margin-bottom: 10px; */\n  color: #fff;\n  background-color: #68dff0;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  cursor: pointer;\n  -webkit-user-select: none;\n  user-select: none;\n  background-image: none;\n  border: 1px solid #48bcb4;\n  padding: 6px 12px;\n  cursor: pointer;\n}\n\n.thumbnailContainerTrans {\n  padding: 5px;\n  position: relative;\n  left: 38.4%;\n  width: 60%;\n}\n\n.transButtonContainer {\n  background: #ffffff;\n  padding: 15px;\n  margin-bottom: 15px;\n  box-sizing: border-box;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  box-shadow: 3px 3px 3px 3px #aab2bd;\n  margin-left: 15%;\n  margin-right: 15%;\n}\n\n.transButtonSearch {\n  color: #fff;\n  background-color: #68dff0;\n  box-shadow: inset 0 3px 5px rgb(0 0 0 / 13%);\n  padding: 6px 12px;\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  border: 1px solid #48bcb4;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.transButtonSearch:hover {\n  background-color: #51cac2;\n}\n\n.transButtonSearch:active {\n  background-color: #327e79;\n}\n\n.fileChooseTransNot {\n  box-sizing: border-box;\n  width: 52%;\n  position: relative;\n  max-height: 35px;\n  font-family: \"Ruda\", sans-serif;\n  margin-left: 4.3%;\n  margin-right: 11%;\n  /* margin-top: 15px; */\n  border-radius: 4px;\n  outline-color: #68dff0;\n  /* margin-bottom: 10px; */\n  color: #fff;\n  background-color: #68dff0;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  cursor: pointer;\n  -webkit-user-select: none;\n  user-select: none;\n  background-image: none;\n  border: 1px solid #48bcb4;\n  padding: 6px 12px;\n  cursor: not-allowed;\n}\n\n.dropdownLabelTrans {\n  font-size: 16px;\n  margin-top: 8px;\n  margin-bottom: 5px;\n  font-weight: 500;\n  margin-right: 3%;\n  width: 20%;\n  margin-left: 9%;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n}\n\n.dropdownSelectTrans {\n  box-sizing: border-box;\n  width: 52%;\n  position: relative;\n  max-height: 35px;\n  padding-right: 15px;\n  padding-left: 15px;\n  color: #555;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  line-height: 1.42857143;\n  margin-left: 4%;\n  margin-right: 11%;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  outline-color: #68dff0;\n  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n}\n\n.loadingDivTrans {\n  display: inline-flex;\n  height: 30px;\n  width: 290px;\n  position: absolute;\n}\n\n.loadingTextDataTrans {\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 16px;\n  margin-top: 8px;\n  margin-bottom: 5px;\n  font-weight: 500;\n  margin-right: 4%;\n  width: 180px;\n  margin-left: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
